// Dữ liệu mẫu tab Tổng quan Chi tiết Job (Mint-JobDetail, job vàng SE260637420). Chỉ đọc, không có tiền.
export type MailKind = 'Khách' | 'Hãng' | 'Đại lý' | 'Nội bộ' | 'Khác';

export const PLAN_STEPS: { label: string; state: 'Xong' | 'Trễ hạn' | 'Chưa tới'; note: string; at?: string }[] = [
  { label: 'Booking confirmed', state: 'Xong', note: '', at: '15/Oct 09:12' },
  { label: 'SI đã gửi', state: 'Xong', note: '', at: '20/Oct 16:40' },
  { label: 'VGM', state: 'Xong', note: '', at: '21/Oct 10:05' },
  { label: 'Draft B/L', state: 'Trễ hạn', note: 'v2 trễ' },
  { label: 'B/L released', state: 'Chưa tới', note: 'sau thanh toán' },
  { label: 'Arrival Notice', state: 'Chưa tới', note: 'sau ETA' },
  { label: 'DO', state: 'Chưa tới', note: 'đại lý LAX' },
];

export const MAIL_FILTERS: { key: 'all' | MailKind; label: string; n: number }[] = [
  { key: 'all', label: 'Tất cả', n: 9 },
  { key: 'Khách', label: 'Khách', n: 2 },
  { key: 'Hãng', label: 'Hãng', n: 3 },
  { key: 'Đại lý', label: 'Đại lý', n: 1 },
  { key: 'Nội bộ', label: 'Nội bộ', n: 1 },
  { key: 'Khác', label: 'Khác', n: 2 },
];

export type MailSt = 'ok' | 'wait' | 'over';
export const MAILS: { party: MailKind; kind: string; from: string; ext?: boolean; subj: string; snip: string; when: string; unread?: boolean; st: MailSt; clock?: string; att: number; n: number; auto?: boolean; autoWhy?: string }[] = [
  { party: 'Khách', kind: 'Draft B/L', from: 'Phòng XNK SAVITA', ext: true, subj: 'Re: Draft B/L v2 · HBL HNSGN260637420', snip: 'Ok bản v2. Nhờ em thêm PO 4500-2231 vào description rồi phát hành nhé.', when: '22/Oct 10:12', unread: true, st: 'wait', clock: "2′", att: 1, n: 2 },
  { party: 'Đại lý', kind: 'Pre-alert', from: 'Harbor Link Logistics', ext: true, subj: 'Pre-alert request · SE260637420 / YM CERTAINTY 089N', snip: 'Please send pre-alert with HBL copy once vessel departs Cat Lai.', when: '22/Oct 09:05', unread: true, st: 'over', clock: "+65′", att: 0, n: 1 },
  { party: 'Hãng', kind: 'Đổi lịch', from: 'Yang Ming VN', ext: true, subj: 'Schedule change · YM CERTAINTY 089N ETD 24/Oct', snip: 'Please be advised ETD revised to 24/Oct 11:00 due to port congestion.', when: '22/Oct 08:02', st: 'ok', att: 1, n: 1 },
  { party: 'Khác', kind: 'Hải quan', from: 'Hải quan CK cảng SG KV1', ext: true, subj: 'Kết quả phân luồng TK 305812447720 · Luồng xanh', snip: 'Tờ khai 305812447720 được phân luồng xanh, thông quan.', when: '21/Oct 14:20', st: 'ok', att: 1, n: 1 },
  { party: 'Khách', kind: 'Debit / Invoice', from: 'LIENNTK', subj: 'Debit note DN26054410 gửi khách', snip: 'Gửi quý khách debit note cho lô SE260637420. Khách đã xác nhận.', when: '21/Oct 11:30', st: 'ok', att: 1, n: 2 },
  { party: 'Hãng', kind: 'SI', from: 'Yang Ming VN', ext: true, subj: 'SI received · YMJAM490371125', snip: 'Shipping instruction received for YMJAM490371125, draft MBL to follow.', when: '20/Oct 16:52', st: 'ok', att: 0, n: 1 },
  { party: 'Nội bộ', kind: 'Vận tải', from: 'ANHLT', subj: 'Lệnh cấp rỗng 2×40HC · SE260637420', snip: 'Đã nhận lệnh cấp rỗng, xếp 2 xe sáng 20/Oct.', when: '19/Oct 16:40', st: 'ok', att: 1, n: 1 },
  { party: 'Khác', kind: 'EIR', from: 'Tân Cảng Cát Lái', ext: true, subj: 'EIR hạ bãi · TGHU8123457 · BKG YMJAM490371125', snip: 'Phiếu EIR hạ bãi cont TGHU8123457 theo booking YMJAM490371125.', when: '22/Oct 10:31', unread: true, st: 'wait', att: 1, n: 1, auto: true, autoWhy: 'Khớp cont TGHU8123457 + booking YMJAM490371125' },
  { party: 'Hãng', kind: 'Booking confirm', from: 'Yang Ming VN', ext: true, subj: 'Booking Confirmation · YMJAM490371125 · YM CERTAINTY 089N', snip: 'Booking confirmed 2x40HC CLI-LAX. SI cut-off 21/Oct 16:00, CY 23/Oct 23:59.', when: '15/Oct 09:10', st: 'ok', att: 1, n: 1 },
];

export const MAIL_SUGGEST: { from: string; subj: string; why: string }[] = [
  { from: 'Yang Ming VN', subj: 'VGM accepted · TGHU8123457 / YMLU5412200', why: 'Khớp số cont TGHU8123457' },
  { from: 'Cảng Cát Lái', subj: 'Thông báo phí lưu bãi · YMJAM490371125', why: 'Khớp booking YMJAM490371125' },
];

export type ActKind = 'mail' | 'chat' | 'st' | 'doc' | 'zns';
export const ACT_FILTERS: { key: 'all' | ActKind; label: string }[] = [
  { key: 'all', label: 'Tất cả' },
  { key: 'mail', label: 'Mail' },
  { key: 'chat', label: 'Chat' },
  { key: 'st', label: 'Trạng thái' },
  { key: 'doc', label: 'Chứng từ' },
  { key: 'zns', label: 'ZNS' },
];
export const ACTIVITY: { kind: ActKind; k: string; who: string; when: string }[] = [
  { kind: 'mail', k: 'Thư mới · Phòng XNK SAVITA · Re: Draft B/L v2', who: 'Phòng XNK SAVITA', when: '22/Oct 10:12' },
  { kind: 'chat', k: 'Nhóm job: "Cont 2 về bãi tầm 15:00 nha chị"', who: 'ANHLT', when: '22/Oct 09:58' },
  { kind: 'zns', k: 'ZNS báo đổi lịch tàu · khách đã đọc', who: 'Hệ thống', when: '22/Oct 09:41' },
  { kind: 'mail', k: 'Thư mới · Harbor Link · Pre-alert request', who: 'Harbor Link Logistics', when: '22/Oct 09:05' },
  { kind: 'doc', k: 'Tải lên ePOD_YMLU5412200.jpg', who: 'HANA Mov', when: '22/Oct 08:40' },
  { kind: 'st', k: 'Đổi ETD 23/Oct 22:00 → 24/Oct 11:00', who: 'PHUONGNKT', when: '22/Oct 08:15' },
  { kind: 'doc', k: 'Tải lên CO_formB_draft.pdf', who: 'NGOCNTB', when: '22/Oct 08:02' },
  { kind: 'chat', k: 'Nhóm job: "@DAVID YML đổi cước từ 01/Nov"', who: 'NHINTT', when: '21/Oct 16:02' },
  { kind: 'zns', k: 'ZNS gửi Draft B/L v2 kèm link myHANA', who: 'Hệ thống', when: '21/Oct 15:21' },
  { kind: 'st', k: 'BK Confirmed → BL Hold · chờ Draft B/L', who: 'MAITTN', when: '21/Oct 15:20' },
  { kind: 'doc', k: 'Khai VGM 2 cont', who: 'MAITTN', when: '21/Oct 10:05' },
  { kind: 'mail', k: 'Gửi SI cho YML', who: 'MAITTN', when: '20/Oct 16:40' },
];

export const MEMOS: { k: string; lv: 'Quan trọng' | 'Lưu ý'; by: string; at: string; exp?: string }[] = [
  { k: 'Khách luôn yêu cầu Telex release, không phát hành bản gốc.', lv: 'Quan trọng', by: 'DAVID', at: '02/Oct/2026' },
  { k: 'Gửi Draft B/L cho cả export@ và accounting@ của khách.', lv: 'Lưu ý', by: 'MAITTN', at: '18/Sep/2026', exp: '31/Dec/2026' },
];

export const ALERTS: { text: string; tone: 'warn' | 'err'; act: string }[] = [
  { text: 'Cut-off CY 23/Oct 23:59 · 1/2 cont chưa hạ bãi', tone: 'warn', act: 'Nhắc điều độ' },
  { text: 'DET free time 2 ngày · TGHU 812 345-6', tone: 'warn', act: 'Xem cont' },
  { text: 'LOI Telex chưa nhận bản ký', tone: 'warn', act: 'Nhắc khách' },
  { text: '1 việc quá hạn · Draft B/L chờ khách', tone: 'err', act: 'Mở việc' },
];

export const TASKS: { title: string; who: string; due: string; tone: 'err' | 'warn' | 'mute'; act: string }[] = [
  { title: 'Khách duyệt Draft B/L v2', who: 'MAITTN', due: '22/Oct 09:00 · quá hạn', tone: 'err', act: 'Nhắc' },
  { title: 'Thiếu LOI Telex bản ký', who: 'MAITTN', due: '23/Oct 17:30', tone: 'warn', act: 'Đã nhận' },
  { title: 'C/O form B chờ phòng TM duyệt', who: 'NGOCNTB', due: '23/Oct 17:30', tone: 'mute', act: 'Nhắc' },
  { title: 'Khoá cước & dịch vụ', who: 'NHINTT', due: '22/Oct 11:00', tone: 'warn', act: 'Khoá' },
  { title: 'Khai báo tàu xuất (VED)', who: 'PHUONGNKT', due: '23/Oct 06:00', tone: 'mute', act: 'Khai' },
  { title: 'Chờ hãng release Telex MBL', who: 'PHUONGNKT', due: 'sau thanh toán', tone: 'mute', act: 'Đề nghị' },
];

export const INFO_SUM = { cnee: 'Pacific Apparel LLC', route: 'VNSGN → USLAX', etd: '24/Oct/2026 11:00', eta: '08/Nov/2026 06:00', vol: '2×40HC' };
export const INFO_ROWS: { label: string; value: string; copy?: boolean; link?: boolean }[] = [
  { label: 'Khách', value: 'SAVITA', link: true },
  { label: 'Shipper', value: 'SAVITA' },
  { label: 'Consignee', value: 'Pacific Apparel LLC' },
  { label: 'Tuyến', value: 'VNSGN → USLAX' },
  { label: 'Hãng · tàu', value: 'YML · YM CERTAINTY 089N', copy: true },
  { label: 'Booking', value: 'YMJAM490371125', copy: true },
  { label: 'HBL', value: 'HNSGN260637420', copy: true },
  { label: 'MBL', value: 'YMJAM490371125', copy: true },
];

// 3 thẻ gập đầu cột trái + 3 thẻ cột phải (Mint-JobDetail `REFS`, `CR`, `CUS`, `ovPeople`, `ovHeiMsgs`, `CL`).
type RefRow = { k: string; v: string; copy?: string; href?: boolean };
export const REFS: { key: string; k: string; open: boolean; rows: RefRow[] }[] = [
  { key: 'r_bk', k: 'Booking & hãng', open: true, rows: [{ k: 'Booking', v: 'YMJAM490371125', copy: 'booking' }, { k: 'Hãng', v: 'YML' }, { k: 'Tàu / chuyến', v: 'YM CERTAINTY 089N', copy: 'tàu' }, { k: 'Báo giá', v: 'Q26FDSGNLAX077', copy: 'báo giá' }, { k: 'Hợp đồng DV', v: 'HĐDV-2026-031' }] },
  { key: 'r_ref', k: 'Tham chiếu lô', open: false, rows: [{ k: 'JobID', v: 'SE260637420', copy: 'JobID' }, { k: 'HBL', v: 'HNSGN260637420', copy: 'HBL' }, { k: 'MBL', v: 'YMJAM490371125', copy: 'MBL' }, { k: 'PO khách', v: '4500-2231', copy: 'PO' }, { k: 'Request', v: 'RQ-2610-318' }] },
  { key: 'r_pty', k: 'Các bên', open: false, rows: [{ k: 'Khách', v: 'SAVITA', href: true }, { k: 'Shipper', v: 'SAVITA' }, { k: 'Consignee', v: 'Pacific Apparel LLC' }, { k: 'Notify', v: 'Same as consignee' }, { k: 'Đại lý đầu đến', v: 'Harbor Link Logistics (LAX)' }, { k: 'Người trả cước', v: 'Shipper · Prepaid' }, { k: 'Incoterm', v: 'FOB Cát Lái' }] },
  { key: 'r_cut', k: 'Lịch & cut-off', open: false, rows: [{ k: 'Closing SI', v: '21/Oct 16:00' }, { k: 'Closing CY', v: '23/Oct 23:59' }, { k: 'Free time', v: 'DEM 5 · DET 7 ngày' }, { k: 'Phụ phí', v: 'THC · AMS · BLF · TLX' }, { k: 'Policy', v: 'Telex sau khi khách thanh toán' }] },
];
export const CONT_ROWS: { no: string; ty: string; st: string }[] = [
  { no: 'TGHU 812 345-7', ty: '40HC', st: 'Chưa hạ' },
  { no: 'YMLU 541 220-0', ty: '40HC', st: 'Đã hạ 22/Oct 08:40' },
];
export const CUS_ROWS: { k: string; v: string; tone: 'ok' | 'warn' | 'pri' }[] = [
  { k: 'Tờ khai xuất 305812447720', v: 'Luồng xanh · thông quan 21/Oct 14:20', tone: 'ok' },
  { k: 'C/O form B', v: 'Chờ phòng thương mại duyệt', tone: 'warn' },
  { k: 'VED khai báo tàu', v: 'Chưa khai · hạn 23/Oct 06:00', tone: 'warn' },
  { k: 'Hun trùng FUM', v: 'Đã đặt lịch 23/Oct 08:00', tone: 'pri' },
];
export const PIC_ROWS: { user: string; role: string }[] = [
  { user: 'DAVID', role: 'Sale' },
  { user: 'MAITTN', role: 'CS' },
  { user: 'NHINTT', role: 'Sale Asst' },
  { user: 'LIENNTK', role: 'Kế toán' },
  { user: 'PHUONGNKT', role: 'BKG · nhận xử lý' },
  { user: 'ANHLT', role: 'Điều độ · được giao' },
  { user: 'ThuyNTT', role: 'Backup' },
];
export const HEI_MSGS: { u: string; k: string; when: string }[] = [
  { u: 'ANHLT', k: 'Cont 2 về bãi tầm 15:00 nha chị', when: '09:58' },
  { u: 'MAITTN', k: 'Khách duyệt Draft v2 rồi, em thêm PO nhé', when: '10:15' },
];
export const CLOSE_LIST: { k: string; ok: boolean }[] = [
  { k: 'C1 Đủ chứng từ bắt buộc', ok: false },
  { k: 'C2 Đã khoá cước', ok: false },
  { k: 'C3 Mọi debit khách đã xác nhận', ok: false },
  { k: 'C4 Đã xuất hoá đơn · chi hộ / thu hộ đã cân', ok: false },
  { k: 'C5 Đủ hoá đơn đối tác / ghép chi phí', ok: false },
  { k: 'C6 Không còn task mở', ok: false },
  { k: 'C7 Đã có ATA / mốc hoàn thành', ok: false },
];
